<template>

  <data-form
    :entity="message"
    :fields="fields"
    :buttons="buttons"
    @submit="submit"
    :cancelAction="stopTimer"
  />

</template>

<script>
import { post } from '../../providers/http'

export default {
  name: 'command-builder',
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      message: {
        topic: 'dlink',
        bytes: ''
      },
      fields: {
        'topic': {
          rules: [{ required: true }, { max: 12 }]
        },
        'bytes': {
          rules: [{ required: true }],
          type: 'textarea'
        },
        'interval': {
          type: 'number'
        }
      }
    }
  },
  methods: {
    submit (data) {
      if (data.interval) {
        clearInterval(this.timerId)

        const interval = data.interval

        delete data.interval

        this.timerId = setInterval(() => this.submit(data), interval)
      }

      post(`api/v1/controllers/command/${this.controller.id}`, data)
    },
    stopTimer () {
      clearInterval(this.timerId)
    }
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  }
}
</script>



// WEBPACK FOOTER //
// CommandBuilder.vue?7d9a97a0